"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DefaultRow = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _material = require("@mui/material");

var _Dropdown = _interopRequireDefault(require("../../../../Dropdown"));

var _IconBtnTooltip = _interopRequireDefault(require("../../../../IconBtnTooltip"));

var _LoadingOverlay = _interopRequireDefault(require("../../../../LoadingOverlay"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DefaultRow = /*#__PURE__*/function (_Component) {
  _inherits(DefaultRow, _Component);

  var _super = _createSuper(DefaultRow);

  function DefaultRow() {
    var _this;

    _classCallCheck(this, DefaultRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onStatusChange", function (row, value) {
      var _this$props = _this.props,
          idKey = _this$props.idKey,
          tableActions = _this$props.tableActions,
          rowData = _this$props.tableData.rowData;
      var updatedRowData = (0, _lodash.cloneDeep)(rowData);
      var rowIndex = updatedRowData.findIndex(function (rowData) {
        return rowData[idKey] === row[idKey];
      });
      updatedRowData[rowIndex].statusOption = value;
      tableActions.updateTableState({
        rowData: updatedRowData
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectRowHandle", function (row, selected) {
      var _this$props2 = _this.props,
          idKey = _this$props2.idKey,
          tableActions = _this$props2.tableActions,
          _this$props2$tableDat = _this$props2.tableData,
          rowData = _this$props2$tableDat.rowData,
          tableSettings = _this$props2$tableDat.tableSettings;
      var updatedRowData = (0, _lodash.cloneDeep)(rowData);
      var rowIndex = updatedRowData.findIndex(function (rowData) {
        return rowData[idKey] === row[idKey];
      });
      updatedRowData[rowIndex].selected = selected;
      var updatedSelectedRows = updatedRowData.filter(function (row) {
        return row.selected;
      });

      var updatedTableSettings = _objectSpread(_objectSpread({}, tableSettings), {}, {
        selectedRows: updatedSelectedRows
      });

      tableActions.updateTableState({
        rowData: updatedRowData,
        tableSettings: updatedTableSettings
      });
    });

    return _this;
  }

  _createClass(DefaultRow, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          dataFormat = _this$props3.dataFormat,
          defaultRowClasses = _this$props3.defaultRowClasses,
          idKey = _this$props3.idKey,
          onRowClick = _this$props3.onRowClick,
          RowMenu = _this$props3.RowMenu,
          tableActions = _this$props3.tableActions,
          _this$props3$tableDat = _this$props3.tableData,
          columns = _this$props3$tableDat.columns,
          selectEnabled = _this$props3$tableDat.selectEnabled,
          statusOptions = _this$props3$tableDat.statusOptions,
          types = _this$props3.types;
      var row = (0, _lodash.cloneDeep)(this.props.row);
      /* eslint-disable no-nested-ternary */

      var onClick = function onClick() {
        return selectEnabled // handles the onRowClick function
        ? _this2.selectRowHandle(row, !row.selected) : onRowClick ? onRowClick(row) : null;
      };

      var rowColumns = tableActions.getVisibleColumns(columns).map(function (column) {
        // eslint-disable-next-line array-callback-return
        if (!column.show) return; // if column.show is false, do not load the column

        if (column.statusOptions !== undefined) {
          // insert Dropdown selection if statusOptions are provided in the columns
          var disabled = column.dropdownDisabled !== undefined ? column.dropdownDisabled : false;
          return /*#__PURE__*/_react["default"].createElement("td", {
            key: "statusOptions",
            className: "SmartTable_statusOption"
          }, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
            value: row.statusOption || statusOptions[0].value // defaults to show first value provided, if statusOption is not yet set
            ,
            onChange: function onChange(value) {
              return _this2.onStatusChange(row, value);
            },
            options: statusOptions,
            FormControlProps: {
              style: {
                margin: 0,
                justifyContent: 'center',
                width: '100%'
              }
            },
            SelectProps: {
              disableUnderline: true,
              disabled: disabled
            }
          }));
        } else {
          // insert a normal row cell
          return /*#__PURE__*/_react["default"].createElement("td", {
            key: "".concat(row[idKey], "_").concat(column.key),
            onClick: onClick,
            style: _objectSpread(_objectSpread(_objectSpread({}, column.type === types.CURRENCY ? {
              textAlign: 'right'
            } : {}), onRowClick ? {
              cursor: 'pointer'
            } : {}), column.customStyle)
          }, column.format ? column.format(row[column.key], row) : dataFormat(row[column.key], column.type));
        }
      }); //// action button object options ////
      // {
      //   label: string, // required
      //   type: string, // required as 'button'
      //   onSelect: func, // optional, passes the row as an argument
      //   loading: func, // optional, passes the row as an argument
      //   disabled: func, // optional, passes the row as an argument
      //   showIf: func, // optional, passes the row as an argument
      //   color: string, // optional, can override the button color, defaults to primary
      //   variant: string, // optional, can override the button variant, defaults to contained
      //   ButtonProps: object, // optional, allows an override of Button props
      // }

      tableActions.actionsByTypeGet(types.ROW_BUTTON).forEach(function (button, actionIndex) {
        var color = button.color || 'primary';
        var loading = button.loading ? button.loading(row) : false;
        var disabled = button.disabled ? button.disabled(row) : false;

        var composedButtonAction = /*#__PURE__*/_react["default"].createElement("td", {
          key: "rowButtonColumn_".concat(button.label).concat(actionIndex),
          className: "SmartTable_buttonColumn"
        }, /*#__PURE__*/_react["default"].createElement(_LoadingOverlay["default"], {
          show: loading,
          width: "100%"
        }, /*#__PURE__*/_react["default"].createElement(_material.Button, _extends({
          color: color,
          variant: button.variant || 'contained',
          onClick: function onClick() {
            return button.onSelect(row);
          },
          disabled: disabled || loading,
          fullWidth: true
        }, button.ButtonProps), button.label)));

        if (button.showIf) {
          if (button.showIf(row)) {
            rowColumns.push(composedButtonAction);
          } else {
            rowColumns.push( /*#__PURE__*/_react["default"].createElement("td", {
              key: "emptyButtonColumn_".concat(button.label).concat(actionIndex),
              className: "SmartTable_buttonColumn"
            }));
          }
        } else {
          rowColumns.push(composedButtonAction);
        }
      });
      tableActions.actionsByTypeGet(types.ROW_ICON).forEach(function (iconAction, actionIndex) {
        var disabled = iconAction.disabled ? iconAction.disabled(row) : false;

        var composedIconAction = /*#__PURE__*/_react["default"].createElement("td", {
          key: "rowIconColumn_".concat(iconAction.icon).concat(actionIndex),
          className: "SmartTable_iconColumn"
        }, /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], _extends({
          icon: iconAction.icon,
          onClick: function onClick() {
            return iconAction.onSelect(row);
          },
          title: iconAction.iconTitle ? iconAction.iconTitle : '',
          buttonProps: {
            disabled: disabled
          }
        }, iconAction.iconProps)));

        if (iconAction.showIf) {
          if (iconAction.showIf(row)) {
            rowColumns.push(composedIconAction);
          } else {
            rowColumns.push( /*#__PURE__*/_react["default"].createElement("td", {
              key: "emptyIconColumn_".concat(iconAction.icon).concat(actionIndex),
              className: "SmartTable_iconColumn"
            }));
          }
        } else {
          rowColumns.push(composedIconAction);
        }
      });
      var rowMenuActions = tableActions.actionsByTypeGet(types.ROW_MENU);

      if (rowMenuActions.length > 0) {
        rowColumns.push( /*#__PURE__*/_react["default"].createElement("td", {
          key: "rowMenuColumn",
          className: "SmartTable_iconColumn"
        }, /*#__PURE__*/_react["default"].createElement(RowMenu, {
          options: rowMenuActions,
          rowData: row
        })));
      }

      if (selectEnabled) {
        rowColumns.unshift( /*#__PURE__*/_react["default"].createElement("td", {
          key: "select",
          className: "SmartTable_selectColumn",
          onClick: onClick,
          style: onRowClick ? {
            cursor: 'pointer'
          } : {}
        }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
          checked: row.selected,
          onChange: function onChange(e, checked) {
            return _this2.selectRowHandle(row, checked);
          }
        })));
      }

      return /*#__PURE__*/_react["default"].createElement("tr", {
        key: row[idKey],
        className: row.selected && selectEnabled ? (defaultRowClasses.tableRow, defaultRowClasses.selectedRow) : defaultRowClasses.tableRow
      }, rowColumns);
    }
  }]);

  return DefaultRow;
}(_react.Component);

exports.DefaultRow = DefaultRow;

_defineProperty(DefaultRow, "propTypes", {
  // from TableRows
  dataFormat: _propTypes["default"].func.isRequired,
  defaultRowClasses: _propTypes["default"].object.isRequired,
  idKey: _propTypes["default"].string.isRequired,
  onRowClick: _propTypes["default"].func,
  row: _propTypes["default"].object.isRequired,
  RowMenu: _propTypes["default"].elementType.isRequired,
  // React component prop
  tableActions: _propTypes["default"].shape({
    actionsByTypeGet: _propTypes["default"].func.isRequired,
    updateTableState: _propTypes["default"].func.isRequired,
    getVisibleColumns: _propTypes["default"].func.isRequired
  }).isRequired,
  tableData: _propTypes["default"].shape({
    columns: _propTypes["default"].array.isRequired,
    rowData: _propTypes["default"].array.isRequired,
    selectEnabled: _propTypes["default"].bool,
    statusOptions: _propTypes["default"].array,
    tableSettings: _propTypes["default"].shape({
      selectedRows: _propTypes["default"].array.isRequired
    }).isRequired
  }).isRequired,
  types: _propTypes["default"].object.isRequired
});

var _default = DefaultRow;
exports["default"] = _default;